import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PatternInvestigationPopupService } from '../services/pattern-investigation-popup.service';
import { CommonService } from '../services/common.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SickLeaveListService } from 'app/services/sick-leave-list.service';

@Component({
  selector: 'app-pattern-investigation-popup',
  templateUrl: './pattern-investigation-popup.component.html',
  styleUrls: ['./pattern-investigation-popup.component.css']
})
export class PatternInvestigationPopupComponent implements OnInit {

  public dataForComparision = [];
  public mainImageUrl;
  public defaultImageUrl;
  public defaultImageName;
  public firstIndex: number;
  public lastIndex: number;
  public currentIndex: number;
  public closePatternViewFlag: boolean;
  public currentImage: number;

  @Input() observedPatternList;
  @Input() sickLeaveDetailsObject;
  @Input() patternViewData;

  @Output()
  closePatternViewEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public sickLeaveService: SickLeaveListService,
    public patternInv: PatternInvestigationPopupService,
    public commonService: CommonService,
    private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    if (this.sickLeaveDetailsObject.absenceInfo.certificateInfo.certificateAttached !== 'N') {

      this.commonService.getCertificate(this.sickLeaveDetailsObject.absenceInfo.certificateInfo.certificateRefID)
        .subscribe(
          (res) => {
            this.mainImageUrl = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,'
              + res.response.base64image);
          }, (err) => {
            if (err.status === 401) {
              alert('You are either unauthorized or your seesion is expired!');
              this.sickLeaveService.redirectToSAB();
            }
          });
    }
    this.patternInv.getCertificatesForComparison(this.sickLeaveDetailsObject.absenceid, this.sickLeaveDetailsObject.empid)
      .subscribe(
        (res) => {
          let obj = JSON.parse(res);
          if (obj.status === 'success') {
            this.get64BaseImage(res.response);
          } else {
            if (obj.status === 'fail') {
              this.defaultImageName = 'Not Available';
              this.dataForComparision = [];
            }
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveService.redirectToSAB();
          }
        }
      );

    this.firstIndex = 0;
    this.currentIndex = this.observedPatternList.indexOf(this.patternViewData);
    this.lastIndex = this.observedPatternList.length - 1;
    this.defaultImageName = this.sickLeaveDetailsObject.absenceId;
  }

  get64BaseImage(dataArray) {
    dataArray.forEach(element => {
      this.commonService.getCertificate(element.certificateid)
        .subscribe(
          (res) => {
            let certificateData;
            certificateData = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,'
              + res.response.base64image);
            let temp = {
              'absenceid': '',
              'certificatesrc': ''
            }
            // temp.absenceid = element.absenceid;
            temp.certificatesrc = certificateData;
            this.dataForComparision.push(temp);
            this.currentImage = 0;
            this.defaultImageName = this.dataForComparision[0].absenceid;
            this.defaultImageUrl = this.dataForComparision[0].certificatesrc;
          }, (err) => {
            if (err.status === 401) {
              alert('You are either unauthorized or your seesion is expired!');
              this.sickLeaveService.redirectToSAB();
            }
          });
    });
  }


  closePopup() {
    this.closePatternViewFlag = true;
    this.closePatternViewEvent.emit(this.closePatternViewFlag);
  }

  moveIntoArray(direction: string) {
    if (direction === 'prev') {
      this.currentIndex--;
      this.patternViewData = this.observedPatternList[this.currentIndex];
    }
    if (direction === 'next') {
      this.currentIndex++;
      this.patternViewData = this.observedPatternList[this.currentIndex];
    }
  }

  setSecondaryImage(img, index) {
    this.currentImage = index;
    this.defaultImageUrl = img.certificatesrc;
    this.defaultImageName = img.absenceid;
  }

}



// WEBPACK FOOTER //
// ./src/app/pattern-investigation-popup/pattern-investigation-popup.component.ts